/**
 * Helper functions for safely updating conversations
 */

import { ConversationItem } from './types';
import { findTargetConversation, updateConversationById as updateConversationByIdUtil } from './conversationUtils';

/**
 * Safely updates a conversation with mount check and target finding
 */
export const safeUpdateConversation = (
  prev: ConversationItem[],
  updates: Partial<ConversationItem> | ((conv: ConversationItem) => ConversationItem),
  isMounted: () => boolean,
  logMessage?: string
): ConversationItem[] => {
  if (!isMounted()) return prev;
  
  const targetConversation = findTargetConversation(prev);
  if (!targetConversation) {
    return prev;
  }

  const conversationId = targetConversation.id;
  return updateConversationByIdUtil(prev, conversationId, updates, logMessage);
};

